module.exports = __webpack_public_path__ + "static/media/R-Smart Max-en.238a479e.jpg";